// /v3/stations/{stationId}/metadata

import { Metadata } from '../../../../types/Metadata';

type Params = {
  webStationId: string;
  userId: number;
  metadata: Metadata;
};

const updatePodcastMetadata = async (params: Params): Promise<number> => {
  const { webStationId, userId, metadata } = params;
  try {
    const response = await fetch(
      `/api/proxy/v3/stations/webStationId:${webStationId}/metadata`,
      {
        method: 'POST',
        credentials: 'same-origin',
        headers: new Headers({
          'Content-Type': 'application/json',
        }),
        body: JSON.stringify({
          userId,
          ...metadata,
        }),
      }
    );
    if (response.ok) {
      return response.status;
    }
    throw new Error(
      `Unable to update podcast metadata for ${webStationId}: ${response.status} - ${response.statusText}`
    );
  } catch (err) {
    throw new Error(err.message);
  }
};

export { updatePodcastMetadata };
